function closeDropdown(exclude) {

    var element;

    // loop through all the filter menus
    if ($('.filters .dropdown-wrapper.opened').length) {
        $('.filters .dropdown-wrapper.opened').each(function () {
            element = $(this);
            if (exclude !== element.attr('data-dropdown')) {
                element.removeClass('opened');
            }
        });
    }

    // loop through all the contact menus
    if($('.menu-wrapper.opened').length) {
        $('.menu-wrapper.opened').each(function() {
            element = $(this);
            if(exclude !== element.attr('data-dropdown')) {
                element.removeClass('opened');
            }
        });
    }

    if($('.status.updating').length) {
        $('.status.updating').each(function () {
            element = $('.status.updating');

            if (exclude !== element.attr('data-dropdown')) {
                element.removeClass('updating');
            }
        });
    }
}

// if clicked out of the dropdown, close the dropdown
// var dropdownDragging = false;

// $('body').on('touchstart', function() {
//     dropdownDragging = false;
// });

// $('body').on('touchmove', function() {
//     dropdownDragging = true;
// });
// $('body').on('click touchend', function(e) {
//     if(dropdownDragging) {
//         return false;
//     }

//     e.stopPropagation();
//     closeDropdown($(e.target).attr('data-dropdown'));
// });

$('body').on('click', function(e) {
    e.stopPropagation();
    closeDropdown($(e.target).attr('data-dropdown'));
});